import { buildMultiDayPresentation } from "./multiDayForecast";
import { backendDayPresentation } from "./seaBassPresentation";
import { localChartTime } from "./hourlyChart";

export const nextLocalDate = (date, offset) => new Date(Date.parse(`${date}T12:00:00Z`) + offset * 86400000).toISOString().slice(0, 10);

// Assemble views, never select winners here. Calendar consumers keep their
// existing data; the rolling card uses only its backend summary and bounds.
export const buildForecastViews = (days, currentTimestamp, rolling, timeZone) => {
  const calendar = buildMultiDayPresentation(days, currentTimestamp);
  if (!rolling) return calendar.map((day) => ({ ...day, viewKey: day.localDate }));
  const referenceDate = localChartTime(rolling.referenceTime, timeZone)?.date;
  if (!referenceDate) return [];
  const future = [1, 2].map((offset) => {
    const localDate = nextLocalDate(referenceDate, offset);
    return { ...(calendar.find((day) => day.localDate === localDate) || {
      localDate, points: [], coverageStatus: "partial", strongest: null,
    }), viewKey: localDate };
  });
  return [backendDayPresentation({ ...rolling, viewKey: "rolling", localDate: referenceDate,
    windowStart: rolling.start, windowEnd: rolling.end, isBestModeledPeriod: false }, rolling.points), ...future];
};
